import { Segment } from "semantic-ui-react";
import { DomainTaskTitle } from "./DomainTaskTitleComponent";
import ComingSoonPlaceholder from '../../Assessment/ComingSoonPlaceholder'
import styles from "./DomainTasks.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

export const LegalDomainTask1 = (questionCompleter: any) => {
  return {
    header: "Getting Legal Documents in Order",
    content: (
      <>
       <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}LegalDocuments.png)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Many families and caregivers wait until a health crisis before
                considering a plan for the older adult's long-term care. It is
                important to develop and review legal documents before anything
                happens to represent the wishes of the older adult. Having an
                updated last will and testament will ensure that assets and
                other property will be divided after their death according to
                their wishes. Power of attorney documents are also important if
                the older adult should reach a point where they are no longer
                able to make their own healthcare or legal decisions.
              </p>
              <p >
                Completion of these documents should help to minimize the stress
                associated with an emergency and maximize the quality of the
                care the older adult receives.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask2 = (questionCompleter: any) => {
  return {
    header: "Establish a Budget Plan",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientVertical} ${styles.imgShiftXZero} ${styles.horizontalFlip}`} 
            style={{ backgroundImage: `url(${cdnRoute}BudgetPlan.png)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Almost half of the elderly in America have limited financial
                assets and more than half of those aged 65 or older receive
                one-half of their income, or more, from social security. At
                least one-half of people aged 65 or older are at risk for
                outliving their assets or encountering an impoverishing event.
              </p>
              <p >
                Helping the older adult get their financial situation in order
                will help to plan for their needs in the coming years. Various
                benefits and sources of income should also be investigated to
                ensure the older adult is taking advantage of all resources
                available to them during their retirement years.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask3 = (questionCompleter: any) => {
  return {
    header: "Exploring Benefits",
    content: (
      <>
       <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}ExploringBenefits.png)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                The federal and state governments have developed programs to
                assist low-income seniors with basic income, health care,
                housing, and food. In addition to these programs, other benefits
                may be available to the older adult that can be helpful to lower
                their overall spend.
              </p>
              <p >
                People who are not eligible for these benefits in mid-life may
                become eligible later in life particularly if they have limited
                retirement resources and/or extraordinary health expenses that
                deplete their savings. In some cases, it is possible to legally
                dispose of assets and thus become eligible. It is best to
                consult with an attorney or financial counselor familiar with
                eligibility requirements to determine if application for such
                benefits is desirable.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask4 = (questionCompleter: any) => {
  return {
    header: "Long-Term Care Planning",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}LongtermPlan4.jpeg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Many older adults will need long-term care services at some
                point in their lives. It is important for older adults and their
                family members/caregivers to understand what the options are,
                the circumstances under which various options might be helpful,
                and the resources that are available to pay for long term care.
              </p>
              <p >
                Many older adults prefer to live at home with in-home services.
                Often these services can be paid for by public programs and
                long-term care insurance. Discussing preferences while the older
                adult is still healthy will make the process much easier when
                the time comes where long-term care is needed.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask5 = (questionCompleter: any) => {
  return {
    header: "Organizing Documents",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`} 
            style={{ backgroundImage: `url(${cdnRoute}organizingdocs_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                A health emergency or death is a complex emotional time. If the older adult and family members have not organized 
                and shared information about the older adult's financial and legal documents, this time can be even more difficult. 
                Ideally, everyone will plan when all are healthy and there is no pressure on them to be sure that important documents 
                are in accessible, fire safe locations.  
              </p>
              <p >
                It is very helpful to compile a list of such documents/information and share it with all who may need it in a crisis. 
                Be especially careful not to put the only copy of a will or advance directive in a safety deposit box. It is often 
                difficult to open safety deposit boxes until after the death of the owner.  In addition to financial and legal documents, 
                as a caregiver you should make and continue to update a list of all the older adult's medical providers and their contact 
                information.  
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask6 = (questionCompleter: any) => {
  return {
    header: "Property Review",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientHorizontal} style={{ backgroundImage: `url(${cdnRoute}PropertyReviewLearnMore2.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Most older adults' only real property is the home in which they live. Adult children can be very helpful in helping 
                parents assess and deal with maintenance needs of their homes. Issues include maintaining the home's value and undertaking 
                preventive maintenance to avoid costly repairs in the future.  
              </p>
              <p >
                Similar issues arise for older adults who own land and rental property. Planning for the long-term use of real property 
                should be considered in the older adult's estate plan. Adopt a plan to clear title to the senior's home and other property, 
                to manage it effectively as a resource and to minimize the cost to the senior of maintenance.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask7 = (questionCompleter: any) => {
  return {
    header: "Family Heirlooms",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`} 
            style={{ backgroundImage: `url(${cdnRoute}familyheirlooms_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                It can be useful to help the older adult develop a list of family valuables (furniture, jewelry, photo albums, etc.) 
                and place the list in a fire safe, secure location and the list can be stored under Documents on this site. You'll 
                also want to help them identify and put in writing their wishes about who will inherit each of the various family 
                valuables after their death.                  
              </p>
              <p >
                Discuss the value of creating a codicil (supplement) to his/her will that details who receives each valuable. Prior 
                to identifying who will inherit what, perhaps the family could tour the home and indicate their preferences. Photographs 
                and comments indicating the meaning of each item will be helpful to those who inherit. Be sure to store this document 
                with the will and other important papers.                 
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask8 = (questionCompleter: any) => {
  return {
    header: "Care of Dependents",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftXZero} ${styles.horizontalFlip}`} 
            style={{ backgroundImage: `url(${cdnRoute}careofdependants_main.jpg)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                If you have a physically or mentally disabled family member for whom the older adult provides care, work with them to 
                make plans for care if the older adult can no longer provide it. Also consider the needs of any grandchildren or other 
                disabled adults for whom the older adult is responsible and take the necessary steps to plan for their future needs. 
              </p>
              <p >
                The Self-Settled Special Needs Trust, oftentimes referred to as a d4A trust, is a first-party trust; meaning, the assets 
                used to fund the trust belong to the beneficiary. This trust allows the beneficiary to have these funds set aside to pay 
                for certain things that government benefits don't provide for, while still allowing the beneficiary to maintain 
                eligibility for public benefits. Special needs trusts are often a good option for aging caregivers who want to provide a 
                source   of funding for the beneficiary's long-term care without putting into jeopardy the beneficiary's eligibility for 
                Medicaid and other public benefits. 
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTask9 = (questionCompleter: any) => {
  return {
    header: "Preventing Fraud",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.horizontalFlip}`} 
            style={{ backgroundImage: `url(${cdnRoute}preventingfraud_main.jpg)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Unfortunately, there are people who target elderly people with all kinds of schemes to separate them from their resources. 
                Internet predators are particularly clever. It is important that your older adult be able to recognize potential fraud 
                schemes and avoid contact with those trying to deceive them. 
              </p>
              <p >
                Talking about the warning signs with older adults can help them to be aware of and avoid common scams. Encourage them to 
                regularly check their bank accounts, credit card balances, and credit reports to ensure there is no suspicious activity. 
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const LegalDomainTaskPlaceholder = () => {
  return {
    header: "Task Coming Soon",
    content: (
      <ComingSoonPlaceholder />
    ),
  };
};
